import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '../../../helpers'

export const NVL_FEATURED_HOME_QUERY_KEY = 'nvl-featured-home'
export const NVL_FEATURED_HOME_LIMIT = 10

export interface FeaturedHomeVendor {
    id: number
    name: string
    featured_image: string | null
    city: string
    state: string
    is_trained: boolean
    will_travel: boolean
    is_skillcat: boolean
    complete_count: number
    distance?: number | null
}

const fetchFeaturedHome = async (
    limit: number,
): Promise<FeaturedHomeVendor[]> => {
    const res = await axiosInstance.get<FeaturedHomeVendor[]>(
        `company/national_vendor_list/featured_home/`,
        { params: { limit } },
    )
    return res.data ?? []
}

export const useNVLFeaturedHome = (limit: number = NVL_FEATURED_HOME_LIMIT) => {
    const query = useQuery<FeaturedHomeVendor[], Error>({
        queryKey: [NVL_FEATURED_HOME_QUERY_KEY, limit],
        queryFn: () => fetchFeaturedHome(limit),
        refetchOnWindowFocus: false,
        staleTime: 60 * 1000,
    })

    return {
        vendors: query.data ?? [],
        isLoading: query.isLoading,
        isFetching: query.isFetching,
        isError: query.isError,
        error: query.error,
    }
}
